import { Reducer } from 'umi';

const namespace = 'opinionCommonOrderLoading';

interface ModuleState {
  couldLoading: boolean;
  data: string[];
}

interface StateType {
  modules: Record<string, ModuleState>;
  keys: string[];
  moduleKeys: string[];
}

function getModuleState(moduleKeys: string[], keys: string[]) {
  const obj = moduleKeys.reduce(
    (pre: Record<string, ModuleState>, cur: string, index: number) => ({
      ...pre,
      // 第一个板块可以加载，其他的不能
      [cur]: { couldLoading: index === 0, data: [] },
    }),
    {},
  );
  return { modules: obj, moduleKeys, keys };
}

const customModel: {
  namespace: string;
  state: StateType;
  reducers: {
    changeLoading: Reducer<
      StateType,
      { payload: { moduleKey: string; key: string }; type: string }
    >;
    initLoading: Reducer<
      StateType,
      { payload: { moduleKeys?: string[]; keys: string[] }; type: string }
    >;
    resetLoading: Reducer<StateType, { type: string }>;
  };
} = {
  namespace,
  state: {
    moduleKeys: [],
    modules: {},
    keys: [],
  },
  reducers: {
    changeLoading(state: StateType, { payload: { moduleKey, key } }) {
      const { modules, keys, moduleKeys } = state;
      const moduleState = modules[moduleKey];

      if (!moduleState) {
        console.warn(`Module ${moduleKey} not found in state`);
        return state;
      }

      const { data } = moduleState;
      const newData = [...data, key];
      const newModules = {
        ...modules,
        [moduleKey]: { couldLoading: true, data: newData },
      };
      // 检查 newData 是否包含 keys 中的所有元素
      const nextItemCouldLoading = keys.every((key) => newData.includes(key));
      if (nextItemCouldLoading) {
        const index = moduleKeys.findIndex(
          (item) => item === String(moduleKey),
        );
        if (index !== -1) {
          const nextModuleKey = moduleKeys[index + 1];
          if (nextModuleKey) {
            const nextModule = modules[nextModuleKey];
            if (!nextModule.couldLoading) {
              newModules[nextModuleKey] = {
                couldLoading: true,
                data: nextModule.data,
              }; 
              // 需要更新 state 中的 moduleKeys 和 modules 字段
              return { ...state, modules: newModules };
            }
          }
        }
        // 不需要更新state
        return state;
      }
      return { ...state, modules: newModules };
    },
    initLoading(state: StateType, { payload: { moduleKeys, keys } }) {
      if (!moduleKeys || !Array.isArray(moduleKeys) || !Array.isArray(keys)) {
        console.warn('Invalid parameters for initLoading');
        return state;
      }

      return getModuleState(moduleKeys, keys);
    },
    resetLoading(state: StateType) {
      const { moduleKeys, keys } = state;
      return getModuleState(moduleKeys, keys);
    },
  },
};

export default customModel;
